@if(wizardStore.C().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-info-label [label]="translationKey + 'formInfo'" />
  </app-card>
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-validated-textarea
      [label]="translationKey + 'riskFactorsLabel'"
      inputFormControlName="riskFactors"
      [inputFormControl]="formGroup.controls.riskFactors"
      [rows]="10"
      [maxLength]="2000"
    />
  </app-card>
</form>

}
